import { DeleteOutlined } from '@ant-design/icons';
import { Button, Card, Form, Input, List, Progress } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';
import { uploadVideoStore } from '../store/uploadVideoStore';
import './UploadVideoList.css';

const UploadVideoList: React.FC = () => {
  return (
    <List
      itemLayout="vertical"
      dataSource={uploadVideoStore.getUploadVideoList()}
      renderItem={uploadVideo => (
        <Card className="upload-video-list-item" hoverable>
          <div className="file-info">
            <div className="file-name">{uploadVideo.name}</div>
            <div className="progress-bar">
              <Progress
                percent={uploadVideo.percent || 0}
                status={
                  uploadVideo.state === 'normal'
                    ? 'normal'
                    : uploadVideo.state === 'uploading'
                      ? 'active'
                      : uploadVideo.state === 'uploaded'
                        ? 'success'
                        : 'exception'
                }
                format={percent =>
                  `${(percent || 0).toFixed(2)}% / ${((uploadVideo.speed || 0) / 1024 / 1024).toFixed(2)} MB/s`
                }
              />
            </div>
          </div>
          <div className="actions">
            <Button
              type="text"
              icon={<DeleteOutlined />}
              onClick={() => uploadVideoStore.removeUploadVideoList(uploadVideo.uid)}
            />
          </div>
          <div className="video-meta">
            <div className="video-info">
              <Form.Item label="Title">
                <Input
                  type="text"
                  value={uploadVideo.title}
                  onChange={e =>
                    uploadVideoStore.updateUploadVideo({ ...uploadVideo, title: e.target.value })
                  }
                />
              </Form.Item>
              <Form.Item label="Synopsis">
                <Input.TextArea
                  value={uploadVideo.synopsis}
                  onChange={e =>
                    uploadVideoStore.updateUploadVideo({ ...uploadVideo, synopsis: e.target.value })
                  }
                />
              </Form.Item>
            </div>
          </div>
        </Card>
      )}
    />
  );
};

export default observer(UploadVideoList);
